import React, { useState, useEffect } from 'react';
import '../css/Translator.css';
import Combobox from './Combobox';
import SpeechRecognition from '../services/SpeechRecognition';
import TalkingParrot from '../services/TalkingParrot';
import { useAuth } from './auth/AuthContext';

var recogObject, talkObject;
export function Translator() {
    const [selectedFromLang, setSelectedFromLang] = useState({ value: "mr", text: "Marathi" });
    const [selectedToLang, setSelectedToLang] = useState({ value: "en", text: "English (US)" });
    const [speechOutput, setSpeechOutput] = useState('');
    const [translateOutput, setTranslateOutput] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const [isTalking, setIsTalking] = useState(false);
    const [isTranslating, setIsTranslating] = useState(false);
    const { secureFetch } = useAuth();

    //Things to happen on load of component
    useEffect(initialize, []);
    //setTimeout(initialize, 700);
    /*
    const [reply, setReply] = useState('');

    var puter = window.puter;

        setLoading('loading');
        puter.ai.chat(query)
            .then(response => {
                setLoading('');
                setReply(response.message.content);
            });
        return false;
    */
    function initialize() {
        //console.log('selectedFromLang', selectedFromLang.value);
        recogObject = SpeechRecognition(selectedFromLang.value);
        recogObject.onCollectResult = function (transcript) {
            setSpeechOutput(currentText => currentText + '\n' +  transcript);
        }

        talkObject = TalkingParrot();
        talkObject.onSpeechEnd = function () {
            setIsTalking(false);
        };
    }

    function onFromLangSelect(e) {
        recogObject.changeLanguage(e.target.value);
        let foundOption = fromLangs.find(c => c.value === e.target.value);
        setSelectedFromLang(foundOption); //Changing the language stops current recording session if any
        setIsRecording(false);
    }
    function onToLangSelect(e) {
        let foundOption = toLangs.find(c => c.value === e.target.value);
        setSelectedToLang(foundOption);
    }

    function toggleRecording(e) {
        //setSpeechOutput("Translator is under development");
        if (isRecording === false) {
            recogObject.startRecording();
            setIsRecording(true);
        } else {
            recogObject.stopRecording();
            setIsRecording(false);
        }
        //console.log('isRecording', recogObject.isRecording);
    }
    function clearRecording(e) {
        //e.preventDefault();
        setSpeechOutput("");
        setTranslateOutput("");
    }
    async function translateNowTest(e) {
        let url = 'api/languageservices/Translate';
        const response = await secureFetch(url);
        const data = await response.json();
        setTranslateOutput(data.translation);
    }

    async function translateNow(e) {
        setIsTranslating(true);
        let url = 'api/languageservices/Translate?';
        const params = {
            srcLang: selectedFromLang.value,
            targetLang: selectedToLang.value
        };
        url += new URLSearchParams(params).toString();
        const response = await secureFetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(speechOutput)
        });
        if (response.ok) {
            const data = await response.json();
            setTranslateOutput(data.translation);
            setIsTranslating(false);
        } else {
            console.error('Error in fetch call:', response.status, response.statusText);
            setIsTranslating(false);
        }
        //setTranslateOutput('Translate Now clicked');
    }

    function speakResult(e) {
        talkObject.speak(selectedToLang.value, translateOutput);
        setIsTalking(true);
    }

    const fromLangs = [
        { value: "mr", text: "Marathi" },
        { value: "hi", text: "Hindi" },
        { value: "en", text: "English (US)" },
        { value: "es", text: "Spanish" },
        { value: "gu", text: "Gujrati" },
        { value: "fr", text: "French" },
        { value: "de", text: "German" },
        { value: "it", text: "Italian" }
    ];
    const toLangs = [].concat(fromLangs); //create a copy and then change first three elements order
    toLangs.splice(0, 3,
        { value: "en", text: "English (US)" },
        { value: "mr", text: "Marathi" },
        { value: "hi", text: "Hindi" }
    );

    return (
        <>
            <h3>Speech Translator</h3>

            <div className="controls">
                <button className={`btn ${isRecording ? 'btn-danger' : 'btn-success'} command-button`} onClick={toggleRecording}>
                    {isRecording ? 'Stop Recording' : 'Start Recording'}
                </button>
                <Combobox title="From Language" cssClass="combo-box" selectedOption={selectedFromLang}
                    availableOptions={fromLangs} onOptionSelect={onFromLangSelect} />
                <button className="btn btn-success command-button" onClick={clearRecording}>Clear...</button>
            </div>
            <div className={isTranslating ? 'loading' : null}>
                <textarea className="output" cols="100" rows="10" value={speechOutput} onChange={(e) => setSpeechOutput(e.target.value)}></textarea>
                {isTranslating && <div class='overlay'></div>}
            </div>

            <div className="controls">
                <button className={`btn ${isTranslating ? 'btn-danger' : 'btn-success'} command-button`} onClick={translateNow}>Translate</button>
                <Combobox title="To Language" cssClass="combo-box" selectedOption={selectedToLang}
                    availableOptions={toLangs} onOptionSelect={onToLangSelect} />
            </div>
            <textarea className="output" cols="100" rows="10" value={translateOutput} onChange={(e) => setTranslateOutput(e.target.value)}></textarea>

            <div className="controls">
                <button className={`btn ${isTalking ? 'btn-danger' : 'btn-success'} command-button`} onClick={speakResult}>
                    {isTalking ? 'Cancel Speaking' : 'Speak above text'}
                </button>
            </div>
        </>
    );
}